import axiosInstance from 'pages/Utility/axiosInstance';
import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { Formik, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Button, FormGroup, Label } from 'reactstrap';
import Select from 'react-select';
import { showError } from 'helpers/notification_helper';

const validationSchema = Yup.object().shape({
    selectedTeam: Yup.object().nullable().required('Team selection is required'),
});

const AddMoreTeams = ({ visible, handleClose, onSubmit, workOrderId, shiftId,solutionId }) => {
    const [teams, setTeams] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchTeams = async () => {
        if(shiftId){
            setLoading(true);
        try {
            const response = await axiosInstance.get('', { params: { sp: 'usp_getTeamsForWorkOrderAssigning', workOrderId, shiftId,solutionId } });
            if (response?.data) {
                setTeams(response?.data?.Data?.map(team => ({ value: team.teamId, label: team.teamName })) || []);
            }
        } catch (error) {
            console.error('Error fetching teams:', error);
        }
        setLoading(false);
        }else{
            showError("Please select the shift")
        }
    };

    useEffect(() => {
        if (visible) {
            fetchTeams();
        }
    }, [visible]);

    return (
        <Modal
            title="Add More Teams"
            visible={visible}
            onCancel={handleClose}
            footer={null}
            destroyOnClose
            centered
            width={400}
            className="custom-modal-header p-0"
            maskClosable={false}
        >
            <div style={{ minHeight: '200px' }} className="d-flex justify-content-center align-items-center">
                {loading ? (
                    <h6>Loading...</h6>
                ) : teams.length === 0 ? (
                    <h6 className="text-center">No teams available</h6>
                ) : (
                    <Formik
                        initialValues={{ selectedTeam: null }}
                        validationSchema={validationSchema}
                        onSubmit={(values, { resetForm }) => {
                            onSubmit(values.selectedTeam?.value,resetForm);
                        }}
                    >
                        {({ setFieldValue, handleReset, values }) => (
                            <Form className="p-2 rounded mx-3 bg-white" style={{ width: '100%' }}>
                                <FormGroup>
                                    <Label>Select Team</Label>
                                    <Select
                                        options={teams}
                                        value={values.selectedTeam}
                                        onChange={(selectedOption) => setFieldValue('selectedTeam', selectedOption)}
                                        placeholder="Select a team"
                                        isClearable={true}
                                    />
                                    <ErrorMessage name="selectedTeam" component="div" className="text-danger mt-1" />
                                </FormGroup>
                                <div className="text-center">
                                    {teams?.length > 0 && (
                                        <Button color="primary" type="submit">
                                            Add Team
                                        </Button>
                                    )}
                                    <Button
                                        color="secondary"
                                        type="button"
                                        className="ms-2"
                                        onClick={() => {
                                            handleReset(); // Reset form on cancel
                                            handleClose();
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                )}
            </div>
        </Modal>
    );
};

export default AddMoreTeams;
